import React, { useState } from 'react';
import { Grid, Box, Typography, IconButton, Chip } from '@mui/material';
import ModalSuscripcion from './ModalSuscripcion';

const tipoColor = {
  'E-BOOK': '#D4A76A',
  'PLANTILLA': '#56CCF2',
  'INFOGRAFÍA': '#D4A76A',
};

const incrementarDescargas = (titulo) => {
  const datos = JSON.parse(sessionStorage.getItem('descargas')) || {};
  datos[titulo] = (datos[titulo] || 0) + 1;
  sessionStorage.setItem('descargas', JSON.stringify(datos));
};

const ArticulosConPaginacion = ({ articulos, estaSuscrito, onSuscribirse }) => {
  const [paginaActual, setPaginaActual] = useState(1);
  const [ordenDescendente, setOrdenDescendente] = useState(true);
  const [busqueda, setBusqueda] = useState('');
  const [modalAbierto, setModalAbierto] = useState(false);
  const articulosPorPagina = 6;

  const articulosConArchivos = articulos.map(articulo => {
    if (!articulo.archivo) {
      const extension = articulo.tipo === 'E-BOOK' ? 'pdf' :
        articulo.tipo === 'PLANTILLA' ? 'xlsx' : 'pdf';
      return {
        ...articulo,
        archivo: `/descargas/${articulo.tipo.toLowerCase()}-${articulo.titulo.toLowerCase().replace(/\s+/g, '-')}.${extension}`
      };
    }
    return articulo;
  });

  const articulosOrdenados = [...articulosConArchivos].sort((a, b) =>
    ordenDescendente
      ? new Date(b.fecha) - new Date(a.fecha)
      : new Date(a.fecha) - new Date(b.fecha)
  );

  const articulosFiltrados = articulosOrdenados.filter((articulo) =>
    articulo.titulo.toLowerCase().includes(busqueda.toLowerCase())
  );

  const totalPaginas = Math.ceil(articulosFiltrados.length / articulosPorPagina);
  const indiceInicial = (paginaActual - 1) * articulosPorPagina;
  const articulosPaginados = articulosFiltrados.slice(
    indiceInicial,
    indiceInicial + articulosPorPagina
  );

  const cambiarPagina = (nuevaPagina) => {
    setPaginaActual(nuevaPagina);
  };

  const handleDownload = (articulo) => {
    if (estaSuscrito && articulo.archivo) {
      incrementarDescargas(articulo.titulo);
      window.open(articulo.archivo, '_blank');
    } else {
      setModalAbierto(true);
    }
  };

  const handleSubmitSuscripcion = (formData) => {
    if (typeof onSuscribirse === 'function') {
      onSuscribirse(formData);
    } else {
      console.error("Error: 'onSuscribirse' prop is not a function in ArticulosConPaginacion. Please check its parent component.");
    }
    setModalAbierto(false);
  };

  return (
    <Box
      sx={{
        backgroundColor: '#1F1F1F',
        py: 6,
        px: { xs: 2, sm: 4, md: 10 },
        backgroundImage: 'url(https://res.cloudinary.com/dhoyyqszi/image/upload/v1750193681/ebm/5395_wugjdu.png)',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <ModalSuscripcion
        open={modalAbierto}
        handleClose={() => setModalAbierto(false)}
        onSubmit={handleSubmitSuscripcion}
      />

      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 6 }}>
        <Box
          sx={{
            width: '315px',
            height: '44px',
            borderRadius: '40px',
            background: 'linear-gradient(rgba(10, 98, 116, 0), rgba(10, 98, 116, 0.5))',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.3)',
            '&::before': {
              content: '""',
              position: 'absolute',
              inset: 0,
              borderRadius: '40px',
              border: '0.64px solid rgba(54, 176, 176, 1)',
              pointerEvents: 'none',
            },
          }}
        >
          <Typography
            sx={{
              color: '#E6E6E6',
              fontFamily: 'Poppins, sans-serif',
              fontSize: '20px',
              fontWeight: 400,
              textAlign: 'center',
              zIndex: 2,
            }}
          >
            Todos los <Box component="span" sx={{ fontWeight: 800 }}>recursos</Box>
          </Typography>
        </Box>
      </Box>

      {/* Filtro y búsqueda */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'space-between',
          alignItems: { xs: 'stretch', sm: 'center' },
          mb: 4,
          gap: 2,
        }}
      >
        <Box
          sx={{
            display: 'inline-flex',
            backgroundColor: '#2E2E2E',
            borderRadius: '50px',
            overflow: 'hidden',
            border: '1px solid #ffffff33',
            backdropFilter: 'blur(6px)',
            boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
          }}
        >
          <Box
            sx={{
              padding: '6px 16px',
              backgroundColor: 'transparent',
              color: '#fff',
              fontSize: '14px',
              fontFamily: 'Poppins, sans-serif',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            Filtrar por
          </Box>
          <Box
            onClick={() => {
              setOrdenDescendente(!ordenDescendente);
              setPaginaActual(1);
            }}
            sx={{
              backgroundColor: '#2a2a2a',
              borderRadius: '30px',
              padding: '6px 16px',
              color: '#fff',
              fontSize: '14px',
              fontFamily: 'Poppins, sans-serif',
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              cursor: 'pointer',
              userSelect: 'none',
            }}
          >
            {ordenDescendente ? '▲ Más recientes' : '▼ Más antiguos'}
          </Box>
        </Box>

        {/* Buscador */}
        <Box
          sx={{
            backgroundColor: '#2a2a2a',
            borderRadius: '30px',
            display: 'flex',
            alignItems: 'center',
            padding: '6px 12px',
            width: { xs: '100%', sm: '300px' },
          }}
        >
          <input
            type="text"
            placeholder="Buscar por tema"
            value={busqueda}
            onChange={(e) => {
              setBusqueda(e.target.value);
              setPaginaActual(1);
            }}
            style={{
              flex: 1,
              backgroundColor: 'transparent',
              border: 'none',
              outline: 'none',
              color: '#fff',
              fontFamily: 'Poppins, sans-serif',
              fontSize: '14px',
            }}
          />
          <Box
            component="img"
            src="https://res.cloudinary.com/dhoyyqszi/image/upload/v1750190221/ebm/iconSearch_oyid1v.svg"
            alt="Buscar"
            sx={{ width: '16px', height: '16px', ml: 1 }}
          />
        </Box>
      </Box>

      {/* Grid de tarjetas */}
      <Grid
        container
        spacing={4}
        justifyContent="center"
        sx={{
          maxWidth: '1000px',
          margin: '0 auto',
        }}
      >
        {articulosPaginados.map((articulo, index) => (
          <Grid
            item
            key={index}
            xs={12}
            sm={6}
            md={4}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              minHeight: '520px',
              px: { xs: 1, sm: 2 },
            }}
          >
            <Box
              sx={{
                backgroundColor: '#00088',
                borderRadius: '20px',
                overflow: 'hidden',
                position: 'relative',
                transition: 'transform 0.3s ease',
                width: '100%',
                maxWidth: '296px',
                height: '100%',
                border: articulo.destacado ? '2px solid #0A6274' : 'none',
                boxShadow: articulo.destacado ? '0 0 15px rgba(10, 98, 116, 0.5)' : 'none',
                '&:hover': {
                  transform: 'translateY(-5px)',
                },
              }}
            >
              <IconButton
                sx={{
                  position: 'absolute',
                  top: 10,
                  right: 8,
                  width: 36,
                  height: 36,
                  borderRadius: '50%',
                  background: 'linear-gradient(90deg, rgba(10, 98, 116, 0.7), rgba(19, 184, 218, 0.6))',
                  border: '1px solid rgba(19, 184, 218, 0.5)',
                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.3)',
                  color: '#fff',
                  zIndex: 1,
                  backdropFilter: 'blur(2px)',
                  WebkitBackdropFilter: 'blur(2px)',
                  transition: 'background 0.3s ease',
                  '&:hover': {
                    background: 'linear-gradient(90deg, #0A6274, #0A6274)',
                  },
                }}
                onClick={() => handleDownload(articulo)} // ← Corrección aquí
              >
                <Box
                  component="img"
                  src="https://res.cloudinary.com/dhoyyqszi/image/upload/v1744825924/ebm/download-icon_al5gur.png"
                  alt="Descargar"
                  sx={{ width: 18, height: 18 }}
                />
              </IconButton>

              <Box
                component="img"
                src={articulo.imagen}
                alt={articulo.titulo}
                sx={{
                  width: '100%',
                  height: '263px',
                  objectFit: 'cover',
                  display: 'block',
                }}
              />

              <Box sx={{ p: 2, minHeight: '120px' }}>
                <Typography
                  sx={{
                    color: '#fff',
                    fontWeight: 500,
                    fontSize: '14px',
                    mb: 1,
                    fontFamily: 'Poppins, sans-serif',
                  }}
                >
                  {articulo.titulo}
                </Typography>

                <Chip
                  label={articulo.tipo}
                  sx={{
                    fontSize: '11px',
                    backgroundColor: tipoColor[articulo.tipo] || '#D4A76A',
                    color: '#fff',
                    borderRadius: '6px',
                    fontWeight: 600,
                    fontFamily: 'Poppins, sans-serif',
                    px: 1.5,
                    height: '24px',
                    mb: articulo.descripcion ? 1.5 : 0,
                  }}
                />

                {articulo.descripcion && (
                  <Typography
                    sx={{
                      color: '#aaa',
                      fontSize: '12px',
                      fontFamily: 'Poppins, sans-serif',
                      fontWeight: 400,
                      lineHeight: 1.4,
                      textAlign: 'justify',
                    }}
                  >
                    {articulo.descripcion}
                  </Typography>
                )}
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* Paginación estilo personalizado */}
      <Box
        sx={{
          mt: 6,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          color: '#fff',
          fontFamily: 'Poppins, sans-serif',
          cursor: 'pointer'
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
          <IconButton
            onClick={() => cambiarPagina(Math.max(paginaActual - 1, 1))}
            disabled={paginaActual === 1}
            sx={{ color: '#fff' }}
          >
            <img src="https://res.cloudinary.com/dhoyyqszi/image/upload/v1750190219/ebm/chevron-left_gsgfk7.svg" alt="Anterior" />
          </IconButton>
          <Typography
            variant="body2"
            sx={{
              fontSize: '16px',
              fontWeight: 400,
              fontFamily: 'Poppins, sans-serif',
            }}
          >
            Página <strong>{paginaActual}</strong> de <strong>{totalPaginas}</strong>
          </Typography>
          <IconButton
            onClick={() => cambiarPagina(Math.min(paginaActual + 1, totalPaginas))}
            disabled={paginaActual === totalPaginas}
            sx={{ color: '#fff' }}
          >
            <img src="https://res.cloudinary.com/dhoyyqszi/image/upload/v1750190222/ebm/chevron-right_zhuboy.svg" alt="Siguiente" />
          </IconButton>
        </Box>

        
       
         
     
      </Box>
    </Box>
  );
};

export default ArticulosConPaginacion;